



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Auth } from "@/service/auth";
import { ElInput } from "element-ui/types/input";
import { ElForm } from "element-ui/types/form";
import { Action } from "vuex-class";
import { MESSAGE } from "@/model/Message";
import { Utils } from "@/service/util";

@Component
export default class LoginBox extends Vue {
  @Prop() title: string;
  @Prop() part: string;

  // デプロイ確認用バージョン値
  private versionLabel: string = process.env.VUE_APP_VERSION;

  formData: any = {
    username: "",
    password: ""
  };
  errorMsg: string = "";
  auth: Auth;

  rules = {
    username: [{ validator: this.validateUser, trigger: "blur" }],
    password: [{ validator: this.validatePass, trigger: "blur" }]
  };

  $refs!: {
    loginForm: ElForm;
    userInput: ElInput;
    pwdInput: ElInput;
  };

  isPc: boolean = true;

  /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [START] */
  isSending: boolean = false;
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [END] */

  public utils: Utils = new Utils();

  @Action("setUser", { namespace: "Authentication" })
  setUser: any;

  get checkPc() {
    return this.isPc;
  }

  touchStart() {
    this.isPc = false;
  }

  // [2024/06/19]コンソール出力掃除
  created() {
    // デプロイ確認用バージョン値出力
    // console.log("FV:" + this.versionLabel);

    this.auth = new Auth();
    this.errorMsg = "";
    // console.log("NODE_ENV", process.env.NODE_ENV);
    // console.log("FV:" + this.versionLabel);
  }

  validateUser(rule: any, value: string, callback: any) {
    if (value === "") {
      callback(new Error(MESSAGE.InvalidUser));
    } else {
      callback();
    }
  }

  validatePass(rule: any, value: string, callback: any) {
    if (value === "") {
      callback(new Error(MESSAGE.InvalidPassWord));
    } else {
      const reg = new RegExp('^[a-zA-Z0-9]*$');
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error(MESSAGE.InvalidAlphanumeric));
      }
    }
  }

  onSubmit() {
    this.$refs.loginForm.validate((valid: boolean) => {
      if (valid) {
        /** 2021-07-28 sh #6989 when login, set token. [START] */
        this.$emit("onloading", true);
        /** 2021-07-28 sh #6989 when login, set token. [END] */
        /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [START] */
        this.$set(this, "isSending", true);
        this.$set(this, "loading", true);
        /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [END] */
        this.auth.login(
          this.formData.username,
          this.formData.password,
          this.part,
          (res: any) => {
            if (res.authenticated) {
              this.setUser(this.formData.username);
              /** 2021-07-28 sh #6989 when login, set token. [START] */
              /** setTimeout は、必須ではないが、演出のため、あったほうがよさげ。 */
              setTimeout(() => {
                this.$emit("onsubmit");
                this.$emit("onloading", false);
                /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [START] */
                this.$set(this, "loading", false);
                /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [END] */
              },300);
              /** 2021-07-28 sh #6989 when login, set token. [END] */
            } else {
              /** 2021-07-28 sh #6989 when login, set token. [START] */
              this.$emit("onloading", false);
              /** 2021-07-28 sh #6989 when login, set token. [END] */
              this.formData.password = "";
              this.$refs.loginForm.clearValidate();
              if (res.error.status < 500 && res.error.rsltComment) {
                this.errorMsg = res.error.rsltComment;
              } else {
                this.errorMsg = MESSAGE.SystemError;
              }
              /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [START] */
              this.$set(this, "isSending", false);
              this.$set(this, "loading", false);
              /** 2022-10-12 sh #8090(BQRxxx) add loding and disabled. [END] */
            }
          }
        );
      }
    });
  }
  goNext() {
    this.focusPassword();
  }
  focusUser() {
    this.$refs.userInput.focus();
  }
  focusPassword() {
    this.$refs.pwdInput.focus();
  }
  onBlur() {
    this.$set(this.formData, "username",  this.utils.removeNonEng(this.formData.username));
  }
}
